import React from 'react';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import { Stack, Typography } from '@mui/material';
import Link from 'next/link';

import { ScreenTitleProps } from './props';

export const ScreenTitle: React.FC<ScreenTitleProps> = (props) => {
  const { title, prevPage, subTitle, titleProps, ...restProps } = props;

  // ======================= VIEWS
  return (
    <Stack
      direction="row"
      alignItems="center"
      {...restProps}
    >
      {prevPage && (
        <Link
          href={`/${prevPage}`}
          style={{
            textDecoration: 'none',
            color: 'inherit',
            width: '24px',
            height: '24px',
          }}
        >
          <ChevronLeftIcon style={{ marginRight: 12, cursor: 'pointer' }} />
        </Link>
      )}
      <Stack>
        <Typography variant="h5" {...titleProps}>
          {title}
        </Typography>
        {subTitle && <Typography>{subTitle}</Typography>}
      </Stack>
    </Stack>
  );
};

// ======================= EXPORT
export * from './props';
export default ScreenTitle;
